import React from 'react';
import classNames from 'classnames';
import styles from './Skeleton.module.css';

const Skeleton = ({ className, dataTestId }) => (
  <i
    data-testid={dataTestId}
    className={classNames(styles.component, className)}
  />
);

export default Skeleton;
